import type { FC } from 'react'

import { SegyConversion, SegyLoading, SegyReady, SegySetup } from '../SegyImport'
import type { StepComponentProps } from '../types'

export const StepSegyComponent: FC<StepComponentProps> = ({
  fileName,
  file,
  activeStep,
  updateFileConfig,
}) => {
  switch (activeStep) {
    case 'setup': {
      return <SegySetup file={file} fileName={fileName} updateFileConfig={updateFileConfig} />
    }
    case 'loading': {
      return <SegyLoading file={file} />
    }
    case 'conversion': {
      return <SegyConversion file={file} />
    }
    case 'ready': {
      return <SegyReady item={file.uploadedFile?.createdEntity} />
    }
    default: {
      return null
    }
  }
}
